import Axios from "axios";
import {
    clearInputsByName,
    fillInputsByName,
    getInputsByName,
    clearFeedbacksByName
} from "../../helpers/forms";
import handleAjaxError from "../../helpers/handleAjaxError";
import {
    toUrl
} from "../../helpers/url";

let punchlistTemplate = null;
let punchlistContainer = null;
let project = null;
let user = null;
let punchlist = [];
let createItemModal = null;
let categorySelector = null;
let isUserView = false;
let type = null;


let fields = [
    'description',
    'notes',
    'id',
];

function initPunchlists(userView = false, _type = 'default') {

    isUserView = userView;
    type = _type;

    createItemModal = document.getElementById('createItemModal');
    categorySelector = document.getElementById('categorySelector');

    categorySelector.onchange = renderPunchlist;


    document.getElementById('confirmCreateItemModal').onclick = saveItem;

    document.querySelector('.button-add').onclick = addPunchList;
    document.querySelector('.Punchlist').classList.remove('d-none');

    const enablePunchlistButton = document.querySelector('.enable-punchlist');
    const disablePunchlistButton = document.querySelector('.disable-punchlist');
    const saveMessageButton = document.querySelector('.save-message');
    if (enablePunchlistButton) {
        enablePunchlistButton.onclick = enablePunchList;
    }
    if (disablePunchlistButton) {
        disablePunchlistButton.onclick = disablePunchlist;
    }
    if (saveMessageButton) {
        saveMessageButton.onclick = savePunchlistMessage;
    }

    punchlistTemplate = document.querySelector('.punchlist-template');
    punchlistContainer = document.querySelector('.punchlist-container');

    project = window.project;
    punchlist = project.punchlist;
    user = window.user;

    if (isUserView && !project.punchlist_enabled) {
        document.querySelector('.button-add').onclick = null;
        document.querySelector('.button-add').classList.add('d-none');
    }

    renderPunchlist();
}

function renderPunchlist() {
    punchlistContainer.innerHTML = '';

    const selectedCategory = categorySelector.value;

    let displayedPunchlist = punchlist;

    if (selectedCategory) {
        displayedPunchlist = displayedPunchlist.filter(item => {
            return item.category_id == selectedCategory;
        })
    }

    punchlist.forEach((item, index) => {

        if (item.type != type) {
            return;
        }

        if (selectedCategory) {
            if (item.category_id != selectedCategory) {
                return;
            }
        }

        if (isUserView) {
            if (item.completed) {
                return;
            }
        }


        createListElement(item, index);
    })

    if (punchlistContainer.children.length) {
        hideEmptyListMessage();
    } else {
        showEmptyListMessage();
    }
}

function addPunchList() {
    clearInputsByName(createItemModal, fields);

    const categoryName = categorySelector.value ? `Add New Item To ${categorySelector[categorySelector.selectedIndex].text}` : 'Create New Item With No Category'
    createItemModal.querySelector('.modal-title').innerText = categoryName;
    document.getElementById('confirmCreateItemModal').innerText = 'Create';

    $(createItemModal).modal('show');
}

function createListElement(item, index) {

    const newPunchList = punchlistTemplate.cloneNode(true);

    const displayIndex = punchlistContainer.children.length + 1;

    clearInputsByName(newPunchList, fields);

    const removeButton = newPunchList.querySelector('.remove-punchlist');

    removeButton.title = 'Remove Item';
    removeButton.onclick = () => removePunchlist(index);

    fillInputsByName(newPunchList, item);

    if (item.id) {
        removeButton.title = 'Delete Item';
        removeButton.querySelector('span').classList.remove('mdi-remove');
        removeButton.querySelector('span').classList.add('mdi-delete');
        removeButton.onclick = () => deletePunchlist(item.id, index);

        newPunchList.querySelector('.edit-item').onclick = (e) => {
            e.preventDefault();
            editItem(item, index)
        };

        if (!item.completed) {
            newPunchList.querySelector('.mark-complete').classList.remove('d-none');
            newPunchList.querySelector('.mark-complete').onclick = () => markComplete(item.id, index);
        } else {
            newPunchList.querySelector('.revert').classList.remove('d-none');
            newPunchList.querySelector('.revert').onclick = () => revert(item.id, index);
        }

        newPunchList.querySelector('.created').innerText = `Created: ${item.created_at_formatted}`;
        newPunchList.querySelector('.updated').innerText = '';
        if (item.created_at_formatted != item.updated_at_formatted) {
            newPunchList.querySelector('.updated').innerText = `Updated: ${item.updated_at_formatted}`;
        }
    }

    if (isUserView) {
        newPunchList.querySelectorAll('.revert,.mark-complete').forEach(button => button.classList.add('d-none'));

        if (item.created_user_id != user.id) {
            newPunchList.querySelectorAll('.dropdown,.remove-punchlist').forEach(button => button.classList.add('d-none'));
        }
        if (!project.punchlist_enabled) {
            newPunchList.querySelectorAll('.dropdown,.remove-punchlist').forEach(button => button.classList.add('d-none'));
        }
    }

    newPunchList.querySelector('.index').innerText = `${displayIndex}.`;
    newPunchList.classList.remove('d-none');

    punchlistContainer.appendChild(newPunchList);
}

function editItem(item, index) {
    clearInputsByName(createItemModal, fields);
    fillInputsByName(createItemModal, item);

    createItemModal.querySelector('.modal-title').innerText = 'Update Item';
    document.getElementById('confirmCreateItemModal').innerText = 'Update';

    $(createItemModal).modal('show');
}

function saveItem() {
    clearFeedbacksByName(createItemModal, fields);

    const data = getInputsByName(createItemModal, fields)

    data.project_id = project.id;
    data.category_id = categorySelector.value;
    data.type = type;

    window.loading();

    let url = toUrl(`/admin/projects/punchlist/store`);
    if (isUserView)
        url = toUrl(`/punchlist/store`);

    Axios.post(url, data)
        .then(response => {
            Swal.fire({
                icon: 'success',
                text: response.data.message,
                timer: 2000,
            }).then(result => {
                window.loading();
                document.location.reload();
            });
        })
        .catch(e => handleAjaxError(e, createItemModal))
        .finally(window.stopLoading);
}

function removePunchlist(index) {
    punchlist.splice(index, 1);

    renderPunchlist();
}

function deletePunchlist(item_id, index) {

    Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete!'
    }).then((result) => {
        if (result.value) {
            window.loading();

            let url = toUrl(`/admin/projects/punchlist/${item_id}/delete`);
            if (isUserView)
                url = toUrl(`/punchlist/${item_id}/delete`);

            Axios.post(url)
                .then(response => {
                    Swal.fire({
                        icon: 'success',
                        text: response.data.message,
                        timer: 2000,
                    });

                    punchlist.splice(index, 1);

                    renderPunchlist();
                })
                .catch(handleAjaxError)
                .finally(window.stopLoading);
        }
    });
}

function markComplete(item_id, index) {

    Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to mark this item as completed?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes!'
    }).then((result) => {
        if (result.value) {
            window.loading();

            Axios.post(toUrl(`/admin/projects/punchlist/${item_id}/complete`))
                .then(response => {
                    Swal.fire({
                        icon: 'success',
                        text: response.data.message,
                        timer: 2000,
                    });

                    punchlist[index] = response.data.item;

                    renderPunchlist();
                })
                .catch(handleAjaxError)
                .finally(window.stopLoading);
        }
    });
}

function revert(item_id, index) {
    Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to mark this item as unfinished?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes!'
    }).then((result) => {
        if (result.value) {
            window.loading();
            Axios.post(toUrl(`/admin/projects/punchlist/${item_id}/revert`))
                .then(response => {
                    Swal.fire({
                        icon: 'success',
                        text: response.data.message,
                        timer: 2000,
                    });

                    punchlist[index] = response.data.item;

                    renderPunchlist();
                })
                .catch(handleAjaxError)
                .finally(window.stopLoading);
        }
    });
}

function enablePunchList() {

    Swal.fire({
        title: 'Enable punchlist for customer',
        html: 'How many days do you want to enable?',
        type: 'warning',
        input: 'text',
        inputValue: 2,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Enable'
    }).then((result) => {
        if (result.value) {

            loading();
            const days = result.value;

            Axios.post(toUrl(`/admin/projects/punchlist/enable`), {
                    project_id: project.id,
					days,
					type
                })
                .then(response => {
                    Swal.fire({
                        icon: 'success',
                        text: response.data.message,
                        timer: 2000,
                    }).then(() => {
                        loading();
                        window.location.reload();
                    });
                })
                .catch(handleAjaxError)
                .finally(stopLoading)

        }
    })
}

function disablePunchlist() {

    loading();

    Axios.post(toUrl(`/admin/projects/punchlist/disable`), {
			project_id: project.id,
			type
        })
        .then(response => {
            Swal.fire({
                icon: 'success',
                text: response.data.message,
                timer: 2000,
            }).then(() => {
                loading();
                window.location.reload();
            });
        })
        .catch(handleAjaxError)
        .finally(stopLoading)
}

function savePunchlistMessage() {
    loading();

    const data = getInputsByName(document, ['punchlist_message']);

    data.project_id = project.id;
	data.type = type;

    Axios.post(toUrl(`/admin/projects/punchlist/message/update`), data)
        .then(response => {
            Swal.fire({
                icon: 'success',
                text: response.data.message,
                timer: 2000,
            });
        })
        .catch(handleAjaxError)
        .finally(window.stopLoading);
}

function hideEmptyListMessage() {
    document.querySelector('.empty-message').classList.add('d-none');

}

function showEmptyListMessage() {
    console.log('showing');
    document.querySelector('.empty-message').classList.remove('d-none');
}

export {
    initPunchlists
};
